import { createApp } from 'vue';
import moment from 'moment';
import 'theme/moydom/less/pages/digital-twin/index.less';
import SubscribeApp from "modules/subscribe/share-app/App.vue";

moment.locale('ru');
const shareApp = createApp({
    components: { SubscribeApp },
    template: '<subscribe-app />',
});


shareApp.mount('#subscriber-app');
